import { useBadgeData, getRejectedSeenAt, markRejectedSeen } from './useBadgeCounts';

export const REJECTED_REQUESTS_COUNT_QUERY_KEY = ['rejected-requests', 'count'];

export { getRejectedSeenAt, markRejectedSeen };

/** Requests of the user's that were rejected since they last opened the Rejected Requests page. */
export function useRejectedRequestCount() {
  return useBadgeData().data?.rejected_requests ?? 0;
}
